// extracted by mini-css-extract-plugin
export default {"layout":"HakoLandingPage_layout__c7RAo","topbar":"HakoLandingPage_topbar__-sjrE","main":"HakoLandingPage_main__Fokga"};